import { CURRENCY_SYMBOLS } from "./currency";
import { v4 as uuidv4 } from "uuid";

export const _formatNumberWithCommas = (amount) => {
  const parts = amount.toString().split(".");
  parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  return parts.join(".");
};

export const moneyFormatter = (currency, number, opts) => {
  if (typeof number !== "number") return;
  if (opts?.divideBy100) number = number / 100;

  const formattedNumber = _formatNumberWithCommas(number.toFixed(2));

  if (!currency) return formattedNumber;
  return `${CURRENCY_SYMBOLS[currency]}${formattedNumber}`;
};

export const coinEarned = (amount) => amount / 100;

export const getSymbolFromCurrency = (cur) => CURRENCY_SYMBOLS[cur];

export const roundToDecimals = (num, decimals) => {
  const factor = Math.pow(10, decimals); // 10^decimals
  return Math.round(num * factor) / factor;
};

export function generateVerificationHash() {
  return uuidv4();
}

export const getUserInitials = (firstName, lastName) => {
  if (!firstName || !lastName) return "";
  return `${firstName.charAt(0).toUpperCase()}${lastName
    .charAt(0)
    .toUpperCase()}`;
};

export const getDeviceId = () => {
  let deviceId = localStorage.getItem("x-device-id");
  if (!deviceId) {
    deviceId = generateVerificationHash();
    localStorage.setItem("x-device-id", deviceId);
  }
  return deviceId;
};
